module.exports = __webpack_public_path__ + "temp-hot-fill.png";